import { Position } from '../../../index';
import Configuration from '../../config/Configuration';
import { Timer } from '../../../utility/Timer';
import _ from 'lodash';
import { Service } from '../Service';
import AuthService from '../../authentication/services/AuthService';
import {
  APP_SETTINGS
} from '../../authentication/services/AuthSettings';

class ActivityService extends Service {
  /**
   * @property {boolean} suspended
   * Tells activity service if timer is suspended
   */
  protected suspended: boolean = true;

  /**
   * @property {Timer} timer
   * Inactivity task is time manager to track inactivity session
   */
  private readonly timer: any;

  /**
   * @property {String[]} trackingEvents
   * List of all events activity tracker should be listening for.
   */
  protected trackingEvents: string[] = ['click', 'keyup', 'mousemove', 'mousewheel'];

  /**
   * Called when the view is created
   */
  constructor(props: any) {
    super();
    _.assign(this, props);

    this.timer = new Timer({
      onTimerFinish: this.onActivityExpired
    });

    // @ts-ignore
    !AuthService.useStoryHelper && this.registerTrackingEvents();
    this.registerServiceToDispatcher();
  }

  /**
   * Activity expired callback.
   */
  onActivityExpired = () => {
    this.dispatch('userIdleWarning', Position.start);
  };

  /**
   * Create activity task manager.
   * This will create Timer task and it will trigger callback fn
   * if interval is breached
   */
  startTracking = (interval?: number) => {
    if (_.isUndefined(interval)) {
      interval = Configuration.get().SESSION_TIMEOUT;
    }
    interval *= 60;
    this.suspended = false;
    this.timer.start(interval);
  };

  /**
   * Attach activity events, eg mouse and keyboard usage
   * This will attach tracking events on page document so that events are tracked on global scope
   */
  registerTrackingEvents = () => {
    this.trackingEvents.map(event => document.addEventListener(event, this.resetActivity.bind(this)));
  };

  /**
   * Restart inactivity handler.
   * This will restart Timer task to restart it's counter
   */
  resetActivity = async () => {
    this.isActivityEnabled()
      .then((enabled) => {
        if (enabled) {
          !this.suspended && this.timer.reset();
        } else {
          this.suspendActivity();
        }
      })
      .catch(() => {
        this.suspendActivity();
      });
  };

  /**
   * Resumes activity timer and service
   */
  resumeActivity = async () => {
    this.isActivityEnabled()
      .then((enabled) => {
        if (enabled) {
          this.suspended = false;
          this.resetActivity();
        } else {
          this.suspendActivity();
        }
      })
      .catch(() => {
        this.suspendActivity();
      });
  };

  /**
   * Returns activity enabled status
   * @returns {Promise<Boolean>}
   */
  isActivityEnabled = async (): Promise<Boolean> => {
    if (AuthService.matchPath(APP_SETTINGS.login_uri)) return new Promise((resolve, reject) => reject(new Error('Activity is not enabled')));
    return await AuthService.isAuthenticated()
      .then(authenticated => authenticated)
      .catch(() => false);
  };

  /**
   * Stop Timer task and this will stop session tracking task
   */
  suspendActivity = () => {
    this.suspended = true;
    this.timer.stop();
  };
}

const ActivityServiceInstance = new ActivityService({});
export default ActivityServiceInstance;
